module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ff0b8beaf649d9206263afcdc403159f.png";